/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  const Inputs = {
    'text_input':                require('gui/inputs/text/vue/text'),
    'texthtml_input':            require('gui/inputs/texthtml/vue/texthtml'),
    'textarea_input':            require('gui/inputs/textarea/vue/textarea'),
    'integer_input':             require('gui/inputs/integer/vue/integer'),
    'string_input':              require('gui/inputs/text/vue/text'), //temporary
    'float_input':               require('gui/inputs/float/vue/float'),
    'radio_input':               require('gui/inputs/radio/vue/radio'),
    'check_input':               require('gui/inputs/checkbox/vue/checkbox'),
    'range_input':               require('gui/inputs/range/vue/range'),
    'datetimepicker_input':      require('gui/inputs/datetimepicker/vue/datetimepicker'),
    'unique_input':              require('gui/inputs/unique/vue/unique'),
    'select_input':              require('gui/inputs/select/vue/select'),
    'media_input':               require('gui/inputs/media/vue/media'),
    'select_autocomplete_input': require('gui/inputs/select/vue/select'),
    'picklayer_input':           require('gui/inputs/picklayer/vue/picklayer'),
    'color_input':               require('gui/inputs/color/vue/color'),
    'slider_input':              require('gui/inputs/sliderrange/vue/sliderrange'),
    'lonlat_input':              require('gui/inputs/lonlat/vue/lonlat'),
  };

  const __vue_script__ = {
    name: "g3w-input",
    props: {
      state: {
        required: true
      },
      addToValidate:{
        type: Function,
        required: true
      },
      removeToValidate:{
        type: Function,
        required: true
      },
      changeInput: {
        type: Function,
        required: true
      }
    },
    components: {
      ...Inputs
    },
    computed: {
      type() {

        /**@since 4.0.7 set integer and bigint as integer input (numeric) */
        if (['integer', 'bigint'].includes(this.state.type)) {
          return 'integer_input';
        }

        //In case of float, use float input (numeric)
        if (['float'].includes(this.state.type)) {
          return 'float_input';
        }

        return this.state.input.type ? `${this.state.input.type}_input`: `${this.state.type}_input`;
        
          
      }
    },
    created() {
      //TEMPORARY
      if (!this.state.input.options) {
        this.state.input.options = {};
      }
    }
  };

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.state.visible)?_c('div',[(_vm.state.type !== 'child')?_c('div',[_c(_vm.type,{tag:"component",attrs:{"changeInput":_vm.changeInput,"addToValidate":_vm.addToValidate,"removeToValidate":_vm.removeToValidate,"state":_vm.state},on:{"changeinput":_vm.changeInput,"addinput":_vm.addToValidate,"removeinput":_vm.removeToValidate}}),_vm._v(" "),_c('divider')],1):_c('div',{staticClass:"skin-border-color field-child",staticStyle:{"border-top":"2px solid"}},[_c('h4',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.state.label))]),_vm._v(" "),_c('div',[_vm._v(" "+_vm._s(_vm.state.description)+" ")]),_vm._v(" "),_vm._l((_vm.state.fields),function(field){return _c('g3w-input',{key:field.name,attrs:{"state":field,"changeInput":_vm.changeInput,"addToValidate":_vm.addToValidate,"removeToValidate":_vm.removeToValidate},on:{"changeinput":_vm.changeInput,"addinput":_vm.addToValidate,"removeinput":_vm.removeToValidate}})})],2)]):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "InputG3W.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__